import { createSlice } from '@reduxjs/toolkit';
import { fetchAgenciesAsync, fetchAgenciesAsyncBuilder } from './asyncRequests';
const initialState = {
    data: [],
    loading: false,
    error: '',
    success: false,
};
export const AgenciesSlice = createSlice({
    name: 'agenciesSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        fetchAgenciesAsyncBuilder(builder);
    },
});
export const AgenciesActions = {
    ...AgenciesSlice.actions,
    fetchAgenciesAsync,
};
export const AgenciesReducer = AgenciesSlice.reducer;
